import React from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";  
import './App.scss';
import PageNotFound from './components/PageNotFound/PageNotFound';
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import ProductDetail from "./components/ProductDetail/ProductDetail";


function App() {
  return (
    <div className='App mb-0'>
     <Router>
       <Header ></Header>
       <div className='container'>
       <Switch>
       <Route  exact path="/" component={Home} />
       
       <Route path="/product/:prdID" component={ProductDetail} />
       <Route component={PageNotFound} />
       </Switch>
       </div>
       <Footer />
     </Router>
    </div>
  );
}

export default App;
